import React from 'react'
import Button from 'material-ui/Button'
import Switch from 'material-ui/Switch'
import { withStyles } from 'material-ui/styles'
import TextField from 'material-ui/TextField'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles'

import Context from './context/'
import Toolbar from './toolbar/'
import User from '../user'
import SearchBar from '../common/search'
import Table from '../table'
import Title from '../ui/title'
import Content from '../ui/content'
import withRole from '../hoc/role'

import Select from 'material-ui/Select'
import { MenuItem } from 'material-ui/Menu'
import Input from 'material-ui/Input'

import ConfirmDialog from '../common/dialog/confirm'

import {
  dateTimeFormatter,
  getISODateString
} from '../../common/utils'

import {
  ROLES_IDEAL,
  ROLES_CLIENT,
  ROLES_IDEAL_ADMIN,
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER
} from '../../common/constants'

import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
import DatePicker from 'material-ui-pickers/DatePicker'
import moment from 'moment'
import MomentUtils from 'material-ui-pickers/utils/moment-utils'
moment.suppressDeprecationWarnings = true;

// const EditButton = withRole((props) => {
//   return (<Button raised onClick={() => props.action()}>{props.title}</Button>)
// }, [...ROLES_IDEAL_ADMIN, ...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER])
// const DeleteButton = withRole((props) => {
//   return (<Button raised onClick={() => props.action()}>{props.title}</Button>)
// }, [...ROLES_IDEAL_ADMIN, ...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER])

const EnableDisableSwitch = withRole((props) => {
  return (<Switch {...props} />)
}, [...ROLES_IDEAL_ADMIN, ...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER], (props) => {
  return (<Switch disabled {...props} />)
})

const IdealRoleSelect = withRole((props) => {
  return (
    <Select
      value={props.value ? props.value : ''}
      onChange={props.onChange}
      input={<Input name="roles" id="roles" value={props.value ? props.value : 'all'} />}
      fullWidth
    >
      <MenuItem value="all">{props.translate("general_showall")}</MenuItem>
      <MenuItem value="idealadmin">{props.translate("idealadmin")}</MenuItem>
      <MenuItem value="idealsupport">{props.translate("idealsupport")}</MenuItem>
    </Select>
  )
}, ROLES_IDEAL)

const ClientRoleSelect = withRole((props) => {
  return (
    <Select
      value={props.value ? props.value : ''}
      onChange={props.onChange}
      input={<Input name="roles" id="roles" value={props.value ? props.value : 'all'} />}
      fullWidth
    >
      <MenuItem value="all">{props.translate("general_showall")}</MenuItem>
      <MenuItem value="clientadmin">{props.translate("clientadmin")}</MenuItem>
      <MenuItem value="clientmanager">{props.translate("clientmanager")}</MenuItem>
      <MenuItem value="clientuser">{props.translate("clientuser")}</MenuItem>
    </Select>
  )
}, ROLES_CLIENT)

class Users extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showConfirmDelete: false,
      showConfirmDisableEnable: false,
      currentRow: null,
      modal: false,
      contextMenu: false,
      selected: {},
      filterable: false,
      selectedDateTime: null
    }
    this.toggle = this.toggle.bind(this);
    this.toggleColumns = this.toggleColumns.bind(this);
    this.add = this.add.bind(this);
    this.del = this.del.bind(this);
    this.toggleEnable = this.toggleEnable.bind(this)
    this.showConfirmDel = this.showConfirmDel.bind(this)
    this.hideConfirmDel = this.hideConfirmDel.bind(this)
    this.showConfirmDisableEnable = this.showConfirmDisableEnable.bind(this)
    this.hideConfirmDisableEnable = this.hideConfirmDisableEnable.bind(this)
  }

  componentWillMount() {
    const { users, pager, translate, classes } = this.props
    const { defaultColumns } = pager
    const {
      filterable,
      selectedDateTime
    } = this.state
    let columns = []
    users.columns.forEach((column, index) => {
      if (column.field === 'enabled') {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          Cell: o => (
            <EnableDisableSwitch
              checked={o.row.enabled}
              onChange={(e) => this.showConfirmDisableEnable(o.row)}
            />
          ),
          toggle: true,
          display: column.display,
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort
        })
      } else if (column.field === 'modifiedat') {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          Cell: o => {
            return o.row.modifiedat ? dateTimeFormatter(o.row.modifiedat) : ''
          },
          toggle: true,
          display: column.display,
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort,
          width: 220,
          Filter: ({ filter, onChange }) => {
            return (
              <React.Fragment>
                <MuiPickersUtilsProvider
                  utils={MomentUtils}
                  moment={moment}
                >
                  <div className="picker">
                    <DatePicker
                      value={selectedDateTime}
                      onChange={event => {
                        this.setState({
                          selectedDateTime: event ? event._d : null
                        }, () => {
                          if (!event) {
                            onChange('')
                            return ''
                          }
                          let date = getISODateString(event._d)
                          onChange(date)
                          return date
                        })
                      }}
                      disableFuture={true}
                      clearable
                      ampm={false}
                      format="DD/MM/YYYY"
                    />
                  </div>
                </MuiPickersUtilsProvider>
              </React.Fragment>
            )
          }
        })
      } else if (column.field === 'role') {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          filterable: column.search && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort,
          show: defaultColumns.includes(column.field),
          toggle: true,
          display: column.display,
          Cell: o => (<React.Fragment>{o.row.role ? translate(o.row.role) : ''}</React.Fragment>),
          Filter: ({ filter, onChange }) =>
            <React.Fragment>
              <IdealRoleSelect onChange={event => onChange(event.target.value === "all" ? '' : event.target.value)} value={filter ? filter.value : "all"} translate={translate} />
              <ClientRoleSelect onChange={event => onChange(event.target.value === "all" ? '' : event.target.value)} value={filter ? filter.value : "all"} translate={translate} />
            </React.Fragment>
        })
      } else if (column.field === "firstname" || column.field === "lastname") {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          toggle: false,
          display: column.display,
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort
        })
      } else {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          toggle: true,
          display: column.display,
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort
        })
      }
    })
    this.setState({
      columns: columns
    })

  }

  impersonate(row) {
    this.props.impersonationRequest({
      uid: row.id,
      CustomerId: row.customerid
    })
  }
  edit(selected) {
    this.props.get(selected)
    this.setState({
      selected: {[selected]:true},
      modal: true,
      mode: 'edit'
    })
  }
  toggle() {
    this.setState({
      contextMenu: !this.state.contextMenu,
    })
  }
  add() {
    this.setState({
      modal: true,
      mode: 'create'
    })
  }
  showConfirmDisableEnable(row) {
    this.setState({
      currentRow: { ...row },
      showConfirmDisableEnable: true
    })
  }
  hideConfirmDisableEnable() {
    this.setState({
      currentRow: null,
      showConfirmDisableEnable: false
    })
  }
  showConfirmDel(selected) {
    let currentSelected = this.props.users.data.filter(user => (user.id === selected))
    if (currentSelected.length) {
      this.setState({
        selected: {[selected]:true},
        currentRow: currentSelected[0],
        showConfirmDelete: true
      })
    }

  }
  loadOrganisationPage(selected) {
    let currentSelected = this.props.users.data.filter(user => (user.id === selected))
    if (currentSelected.length > 0) {
      window.location.href = "/organisation/" + currentSelected[0].customerid;
    }
  }
  hideConfirmDel() {
    this.setState({
      currentRow: null,
      showConfirmDelete: false
    })
  }
  del() {
    this.props.del(this.state.currentRow.id).then(resp => {
      this.setState({
        selected: {}
      })
    })
    this.hideConfirmDel();
  }
  toggleEnable() {
    this.props.toggleEnable(this.state.currentRow.id, this.state.currentRow.enabled);
    this.hideConfirmDisableEnable();
  }
  toggleColumns(column) {

    let columns = [...this.state.columns]

    columns.forEach((c) => {
      if (c.id === column.id) {
        c.show = column.show
      }
    })
    this.setState({
      columns: columns
    })
  }
  closeModal() {
    this.props.reset()
    this.setState({
      modal: false
    })
  }

  selectedRows = (rows) => {
    this.setState({
      selected: rows
    })
  }

  toggleFilters = () => {
    let columns = [...this.state.columns]
    let { filterable } = this.state
    columns.forEach((c) => {
      c.filterable = c.cansearch && !filterable
    })
    this.setState({
      columns: columns,
      filterable: !filterable
    })
  }

  setColumns(props) {
    const {
      filterable,
      selectedDateTime,
      columns
    } = this.state

    let col = columns.find(col => col.id === 'modifiedat')
    if (col) {
      col.Filter = ({ filter, onChange }) => {
        return (
          <React.Fragment>
            <MuiPickersUtilsProvider
              utils={MomentUtils}
              moment={moment}
            >
              <div className="picker">
                <DatePicker
                  value={selectedDateTime}
                  onChange={event => {
                    this.setState({
                      selectedDateTime: event ? event._d : null
                    }, () => {
                      if (!event) {
                        onChange('')
                        return ''
                      }
                      let date = getISODateString(event._d)
                      onChange(date)
                      return date
                    })
                  }}
                  disableFuture={true}
                  clearable
                  ampm={false}
                  format="DD/MM/YYYY"
                />
              </div>
            </MuiPickersUtilsProvider>
          </React.Fragment>
        )
      }
    }


    this.setState({
      columns: columns
    })
  }

  componentWillReceiveProps(nextProps) {
    const props = { ...nextProps }
    this.setColumns(props)
  }

  removedSelectedUserRadioCheck = () => {
    this.setState({
      selected: {}
    })
  }

  render() {

    const {
      translate,
      languages,
      profile,
      users,
      user,
      pager,
      fetch,
      search,
      create,
      update,
      error,
      errorMessage,
      reset,
      impersonating,
      softwareUpdate,
      viewingAllUsers
    } = this.props

    const {
      selected,
      columns,
      filterable
    } = this.state

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    const _selected = { ...selected }
    let selectedRecords = Object.keys(selected).filter(x => selected[x])
    let $context = (
      <Context
        toggleColumns={this.toggleColumns}
        data={users.data}
        translate={translate}
        columns={this.state.columns}
      />
    )
    let $modal = this.state.modal ? (
      <User translate={translate}
        pager={pager}
        profile={profile}
        languages={languages}
        mode={this.state.mode}
        modal={this.state.modal}
        close={this.closeModal.bind(this)}
        create={create}
        update={update}
        user={user}
        error={error}
        errorMessage={errorMessage}
        removedSelectedUserRadioCheck={this.removedSelectedUserRadioCheck}
        reset={reset}
      />
    ) : null
    let confirmDeleteText = translate('user_delete_confirm_text', {
      firstname: (this.state.currentRow && this.state.currentRow.firstname) ? this.state.currentRow.firstname : '',
      lastname: (this.state.currentRow && this.state.currentRow.lastname) ? this.state.currentRow.lastname : '',
      email: (this.state.currentRow && this.state.currentRow.email) ? this.state.currentRow.email : ''
    })

    let confirmEnableText = translate('user_enable_confirm_text', {
      firstname: (this.state.currentRow && this.state.currentRow.firstname) ? this.state.currentRow.firstname : '',
      lastname: (this.state.currentRow && this.state.currentRow.lastname) ? this.state.currentRow.lastname : '',
      email: (this.state.currentRow && this.state.currentRow.email) ? this.state.currentRow.email : ''
    })
    let confirmDisableText = translate('user_disable_confirm_text', {
      firstname: (this.state.currentRow && this.state.currentRow.firstname) ? this.state.currentRow.firstname : '',
      lastname: (this.state.currentRow && this.state.currentRow.lastname) ? this.state.currentRow.lastname : '',
      email: (this.state.currentRow && this.state.currentRow.email) ? this.state.currentRow.email : ''
    })

    return (
      <div style={{marginTop: margintop}}>
        <Title
          title={viewingAllUsers ? translate("all_users") : translate("general_users")}
          toolbar={<Toolbar
            translate={translate}
            toggle={() => this.toggle()}
            add={() => this.add()}
            edit={() => this.edit(selectedRecords[0])}
            remove={() => this.showConfirmDel(selectedRecords[0])}
            loadOrganisationPage={() => this.loadOrganisationPage(selectedRecords[0])}
            selectedRecords={selectedRecords}
            toggleFilters={this.toggleFilters}
            data={users.data}
            profile={profile}
            viewingAllUsers={viewingAllUsers}
          />}
        />
        <Content ctx={$context} open={this.state.contextMenu} toggle={() => this.toggle()} translate={translate}>
          {filterable ? (<SearchBar search={search} pager={pager} translate={translate} />) : null}
          <Table
            translate={translate}
            filterable={filterable}
            pages={users.pagecount}
            manual={pager.manual}
            defaultPageSize={pager.pagesize}
            data={users.data}
            pager={pager}
            columns={columns}
            fetch={fetch}
            allowSelectOne
            selectedRows={this.selectedRows}
            selected={_selected}
            minRows={0}
            style={{
              border: 'none',
            }}
            noDataText="no_users_data"
          />
        </Content>
        {$modal}
        <ConfirmDialog
          open={this.state.showConfirmDelete}
          title={translate('user_delete_confirm_title')}
          contentText={confirmDeleteText}
          contentSecondaryText={translate('general_confirmation_help_2')}
          okText={translate('general_confirm')}
          cancelText={translate('general_cancel')}
          onOk={this.del}
          onCancel={this.hideConfirmDel}
        />
        <ConfirmDialog
          open={this.state.showConfirmDisableEnable}
          title={(this.state.currentRow && this.state.currentRow.enabled) ? translate('user_disable_confirm_title') : translate('user_enable_confirm_title')}
          contentText={(this.state.currentRow && this.state.currentRow.enabled) ? confirmDisableText : confirmEnableText}
          contentSecondaryText={translate('general_confirmation_help_1')}
          okText={translate('general_confirm')}
          cancelText={translate('general_cancel')}
          onOk={this.toggleEnable}
          onCancel={this.hideConfirmDisableEnable}
        />
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Users);
